import { ModelConfigParams, genericEnd, genericStartQC } from "./model-config-params";

const pancreasMiddleChecklist = [
  "Stomach and pancreas - have been identified and labelled correctly",
  "Arteries - all have been identified, correctly labelled and conform to the standard classification",
  "Veins - all have been identified, correctly labelled and conform to the standard classification",
  "Lesion (tumour) - has been identified and correctly labelled according the information received in the case notes",
]

export const pancreas: ModelConfigParams = {
  bodyParts: [
    'tumourWithLesionUncertain',
    'tumourMargin',
    'arteryWithDetailAndUncertainAndParts',
    'veinWithDetailAndUncertainAndParts',
    'stomach',
    'pancreas',
    'colon',
    'kidney',
    'spleen',
    'gallBladder',
    'bileDuct',
    'bladder',
    'collectingColorectal',
    'liver',
    'uterus',
    'bone',
    'stent',
    'unknown',
    'calcification',
    'lymph',
    'portalVein',
  ],
  checklist: [
    "Check Stomach",
    "Check Pancreas",
    "Check Aorta",
    "Check Henle’s trunk",
  ],
  checklistQC: [
    genericStartQC,
    pancreasMiddleChecklist,
    genericEnd,
  ].flat(),
  tissueHotkeys: {
    tumour: 'q',
    artery: 'w',
    vein: 'e',
    portalVein: 'r',
    arteryUncertain: "t",
    lymph: "u",
    veinUncertain: "y",
    colon: "i",
    stomach: "o",
    pancreas: "p",
    aorta: "alt + q",
  },
  defaultIntensityRange: [-200, 400],
}